<article class="feed-card-container cursor-pointer" role="button" tabindex="0"
    (click)="viewApplicants()" (keydown)="onCardKeydown($event)"
    [attr.aria-label]="'View applicants'">

    <div class="flex w-full min-w-0 flex-row items-start justify-between gap-3">

        <div class="flex min-w-0 flex-1 items-center">
            <div class="shrink-0">
                <div
                    class="size-12 rounded-lg flex items-center justify-center bg-blue-50 dark:bg-blue-900/30 dark:pill-blue-900/30">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6 text-blue-500" aria-hidden="true">
                        <path
                            d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                        <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                        <path d="M16 22a4 4 0 0 0-8 0" />
                        <circle cx="12" cy="15" r="3" />
                    </svg>
                </div>
            </div>
            <div class="ml-3 min-w-0 flex-1">
                <h3 class="truncate text-base font-semibold text-primary">{{ activity.briefApplications && activity.briefApplications.length > 0 ? activity.briefApplications.length : 0}}
                    Creators Applied!</h3>
                <p class="truncate text-sm text-secondary">
                    {{ activity.briefApplications && activity.briefApplications.length > 0 ? activity.briefApplications.length : 0 }} creators have applied for this brief.
                </p>
            </div>
        </div>

        <div class="flex shrink-0 flex-col items-end justify-start">
            <p class="text-sm text-secondary">
                {{ formatService.getTimeSinceUpdated(activity.date) }}
            </p>
        </div>
    </div>

    <div class="flex w-full min-w-0 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">

        @if (activity.briefApplications && activity.briefApplications.length > 0) {
        <div class="flex min-w-0 overflow-hidden">
            <div class="flex -space-x-1">
                <dt class="sr-only">Applicants</dt>
                @for (application of activity.briefApplications.slice(0, 5); track application.id) {
                <dd class="relative size-10 shrink-0 text-blue-500 rounded-full outline-2 outline-blue-500">
                    <img [src]="imageService.getImageSource(application.creator.photoURL, 'gallery')" alt=""
                        class="size-10 rounded-full bg-gray-50 dark:bg-gray-800 dark:outline-gray-900" />
                </dd>
                }
                @if (activity.briefApplications.length > 5) {
                <dd
                    class="relative z-10 flex size-10 shrink-0 items-center justify-center rounded-full bg-blue-100 text-xs font-semibold text-blue-700 outline-2 outline-blue-500 dark:bg-blue-900/50 dark:text-blue-200">
                    +{{ activity.briefApplications.length - 5 }}
                </dd>
                }
            </div>
        </div>
        }

        <div class="shrink-0 self-start sm:self-auto">
            <span
                class="inline-flex items-center gap-x-1.5 rounded-full bg-blue-600 px-2.5 py-1.5 text-sm text-white shadow-xs dark:bg-blue-500 dark:shadow-none"
                aria-hidden="true">
                View Applicants
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="-mr-0.5 size-5">
                    <path
                        d="M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z" />
                    <path d="M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" />
                </svg>
            </span>
        </div>
    </div>

</article>
